import styled, { css } from 'styled-components';

export interface StyledInputProps {
  $error?: boolean;
}

export const StyledInput = styled.input<StyledInputProps>`
  border: 1px solid rgba(227, 227, 227, 1);
  border-radius: 2px;
  width: auto;
  height: 40px;
  margin: 10px 0 10px 0;
  padding: 0 10px 0 10px;
  font-size: 16px;

  ${({ $error }) => {
    if ($error) {
      return css`
        border-color: red;
      `;
    }
  }}
`;
